export default __webpack_public_path__ + "2a857b086d435f6a461dc0719e86b91a.svg";